<template lang="pug">
  .service-container
    .service-container__header.service-container__header__bg1
      .service-container__title {{ $t('主流媒介资源直采') }}

      .service-container__desc {{ $t('“贵了么”小程序对接海量主流供应商，从而获取远低于市场政策的一手价格，') }}
      .service-container__desc {{ $t('为企业避开层层中间商，使得媒介资源采购从此安心与省心。') }}
      .service-container__desc {{ $t('已对接1,000+供应商的近300个媒体资源和20,000个KOL资源。') }}
    .service-content-container
      .service-container__subTitle
        img(src="@/assets/icon-challenge.png")
        .subTitle {{ $t('企业面临的挑战与痛点') }}

      .service-challenge-container.service-challenge-container__min
        .challenge__item
          img(
            src="@/assets/service-challenge-img.png"
          )
          i.iconfont.iconshujufensan
          .item__title {{ $t('有谁卖/多少钱') }}
          .item__desc {{ $t('当企业有媒介投放需求时，如果是企业非常熟悉的渠道则有固定的供应商，而当需要尝试新渠道时，则会面临一种情况：市场中谁做这块资源？价格有无竞争力？缺少一个参考标准。') }}
        .challenge__item
          img(
            src="@/assets/service-challenge-img.png"
          )
          i.iconfont.iconxiaoshuai
          .item__title {{ $t('中间商赚差价') }}
          .item__desc {{ $t('在企业寻找媒介供应商时，由于供应链不透明，经过一级二级乃至三级代理商的中间商倒手后，实际100元的预算，到最终媒体供应商执行时只有50元预算。如何防止中间商赚差价，成了企业头大的问题。') }}
      .service-container__subTitle
        img(src="@/assets/icon-project.png")
        .subTitle {{ $t('复歌的解决方案') }}

      .service-solution-container
        .solution-item
          .solution-content
            .solution-content__title {{ $t('供应商网络') }}
            .solution-content__desc {{ $t('复歌基于官方小程序“贵了么”平台，整合了行业中绝大部分主流核心供应商，因此累计了海量的供应商信息及资源报价信息，同时贵了么通过标准化分类，把所有供应商的业务类型、服务范围、资源属性进行了标准化，无论想采购哪类媒介资源都可以快速找到。')}}
            .solution-content__link(
              @click="$router.push('/product/guileme')"
            )
              img(src="@/assets/logo-guileme.png")
              span {{ $t('贵了么') }}
              img.icon-entrance(src="@/assets/icon-entrance.png")

          img(
            src="@/assets/service-resource-1.png"
          )
        .solution-item
          .solution-content
            .solution-content__title {{ $t('获取最优政策') }}
            .solution-content__desc {{ $t('复歌通过贵了么小程序对接各类媒介资源的一级代理商，从而获取大量底价政策，因此如果企业通过复歌进行媒介资源集采，不仅可以避免各种无法控制的中间环节同时用最少的钱买到相同的资源，使得采购成本降到最低。') }}
            .solution-content__link(
              @click="$router.push('/product/guileme')"
            )
              img(src="@/assets/logo-guileme.png")
              span {{ $t('贵了么') }}
              img.icon-entrance(src="@/assets/icon-entrance.png")
          img(
            src="@/assets/service-resource-2.png"
          )
    mobile-case-sample(
      :data="caseList"
    )
    mobile-contact
</template>

<script>
import MobileContact from '@/components/MobileContact'
import MobileCaseSample from '@/components/MobileCaseSample'

export default {
  components: {
    MobileContact,
    MobileCaseSample
  },
  data () {
    return {
      caseList: [
        {
          url: '/case/purchasing-bayer',
          img: require('@/assets/case-bayer.png'),
          title: '虫虫拜拜',
          desc: '从供应商选择到数据展示的一站式解决方案。'
        }
      ]
    }
  }
}
</script>
